import { Controller } from "@hotwired/stimulus"

export default class TicketCategoryController extends Controller {
  static targets = ["prompt", "options", "contextMessage", "bestOption",
    "optionButton", "otherOptions", "otherOptionItem", "panel"]

  declare readonly panelTarget: HTMLElement
  declare readonly optionsTargets: HTMLElement[]

  select(event: Event): void {
    const radio = event.currentTarget as HTMLInputElement
    const panelKey = radio.value;

    this.panelTarget.classList.remove("is-completely-hidden")

    this.optionsTargets.forEach(el => {
      el.classList.toggle("is-completely-hidden", el.dataset.ticketCategoryKey !== panelKey)
    })
  }
}